var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"welcome"},[_c('language-switch',{staticClass:"welcome__language"}),_c('transition',{attrs:{"name":"fade","mode":"out-in"},on:{"before-enter":_vm.scrollToTop}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }